import { render, staticRenderFns } from "./hotel_details.vue?vue&type=template&id=96dab64c&"
import script from "./hotel_details.vue?vue&type=script&lang=js&"
export * from "./hotel_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports